import { FC } from 'react';
import { Box } from '@updater/ui-uds';
import { PlanResultsContainer, ResultsSortPills } from '@updater/ui-widgets';
import { SortPill, SORT_PILL_LABELS } from 'constants/sortPills';

const PILLS = [
  SortPill.Recommended,
  SortPill.Speed,
  SortPill.BestValue,
  SortPill.Price,
].map((pill) => ({ value: pill, label: SORT_PILL_LABELS[pill] }));

interface SortPillsProps {
  activePill: SortPill;
  onChange: (pill: SortPill) => void;
}

// The container lets the pills drop their Compact edge bleed on wider columns.
export const SortPills: FC<SortPillsProps> = ({ activePill, onChange }) => (
  <Box mb="m">
    <PlanResultsContainer>
      <ResultsSortPills
        pills={PILLS}
        activePill={activePill}
        onChange={onChange}
      />
    </PlanResultsContainer>
  </Box>
);
